export class BankAccountDto {
    public id: number | undefined = undefined;
    public creditInstitute: string | undefined = undefined;
    public iban: string | undefined = undefined;
    public bic: string | undefined = undefined;
    public accountOwnerName: string | undefined = undefined;
}
